import { ProductType } from '@/models/ad';

export type SummaryPriceResponse = {
  result: PriceSummary;
};

export type PriceSummary = {
  vat: number;
  image: number;
  video15s: number;
  video30s: number;
  promo?: number;
};

export enum SummaryType {
  FINAL_PRICE = 1,
  PRICE_SUMMARY = 2,
}

export type SummaryBody = {
  zones?: number[];
  type: string;
  displays?: number;
  views?: number;
  summaryType: SummaryType;
};

export type FinalPrice = {
  prices?: PriceSummary;
  type: ProductType;
  zones: number[];
  displays?: number;
  views?: number;
};
